<medpace-page>
    <div class="flex flex-col gap-medpace items-center">
        @if (isSuccess()) {
            <medpace-alert [content]="'Request has been sent successfully.'" [appearance]="'highlight'" />
        }

        @if (!isGuidValid()) {
            <medpace-alert content="There is no invitation in the system." [appearance]="'caution'" />
        }

        @if (!isValidAuthUserEmail()) {
            <medpace-alert
                content="The authenticated user's email does not match the invitation."
                [appearance]="'caution'"
            />
        }

        @if (invitation() && !isSuccess() && isGuidValid() && isValidAuthUserEmail()) {
            <mds-card>
                <mds-card-content class="gap-medpace w-[750px]">
                    <h3>{{ title() }}</h3>
                    <div class="pt-8">
                        <h5>Affected Studies</h5>
                        @for (protocol of invitation()!.studiesProtocol; track protocol) {
                            <p class="break-all">{{ protocol }}</p>
                        }
                    </div>
                    <div class="pt-8">
                        <h5>Affected Sites</h5>
                        @for (siteName of invitation()!.sitesName; track siteName) {
                            <p class="break-all">{{ siteName }}</p>
                        }
                    </div>
                    <div class="pt-8">
                        <h5>Access Type</h5>
                        <p class="break-all">
                            @if (invitation()!.isPrimary !== null) {
                                {{ invitation()!.isPrimary ? 'Primary' : 'Supporting' }}
                            }
                            {{ invitation()!.accessGroupName }}
                        </p>
                    </div>
                    @if (!isFormGroupVisible()) {
                        <div class="pt-8">
                            <h5>Email Address</h5>
                            <p class="break-all">{{ invitation()!.userEmail }}</p>
                        </div>
                    }

                    @if (isFormGroupVisible()) {
                        <form #ngForm="ngForm" [formGroup]="formGroup">
                            <div class="flex flex-col gap-medpace pt-8">
                                <mds-text-field
                                    [formCtrl]="formGroup.controls.emailAddress"
                                    [id]="'email'"
                                    [placeholder]="'Type here...'"
                                    [appearance]="'outline'"
                                    [inputType]="'text'"
                                    [label]="'Email Address'"
                                    [aria-label]="'None'"
                                    [required]="true"
                                />
                                <mds-text-field
                                    [formCtrl]="formGroup.controls.firstName"
                                    [id]="'first-name'"
                                    [placeholder]="'Type here...'"
                                    [appearance]="'outline'"
                                    [inputType]="'text'"
                                    [label]="'First Name'"
                                    [aria-label]="'None'"
                                    [required]="true"
                                />
                                <mds-text-field
                                    [formCtrl]="formGroup.controls.lastName"
                                    [id]="'last-name'"
                                    [placeholder]="'Type here...'"
                                    [appearance]="'outline'"
                                    [inputType]="'text'"
                                    [label]="'Last Name'"
                                    [aria-label]="'None'"
                                    [required]="true"
                                />
                                <mds-text-field
                                    [formCtrl]="formGroup.controls.phoneNumber"
                                    [id]="'phone-number'"
                                    [placeholder]="'Type here...'"
                                    [appearance]="'outline'"
                                    [inputType]="'tel'"
                                    [label]="'Phone Number'"
                                    [required]="true"
                                />
                                <mds-textarea
                                    [formCtrl]="formGroup.controls.justification"
                                    [id]="'justification'"
                                    [placeholder]="'Type here...'"
                                    [appearance]="'outline'"
                                    [label]="'Justification'"
                                >
                                </mds-textarea>
                            </div>
                        </form>
                    }
                </mds-card-content>
                <mds-card-actions>
                    <mds-button
                        [label]="'Send'"
                        [color]="'primary'"
                        [variant]="'filled'"
                        [id]="'sendBtn'"
                        (clickEvent)="sendRequest()"
                    />
                </mds-card-actions>
            </mds-card>
        }
    </div>

    @if (isLoading()) {
        <medpace-loading />
    }
</medpace-page>
